import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { map, take } from "rxjs";
import { PlatformAlertsService } from "src/app/shared/services/platform-alerts/platform-alerts.service";

export const ACCOUNT_BLOCKED_PATH = "account-blocked";

/**
 * Sends every user to the "Cuenta bloqueada" page once billingBlockLevel reaches 4
 * (rules in PlatformAlertsService.totalBlock$). Meant to be registered as both
 * canActivate and canActivateChild on the root route of a subtree, so it runs on
 * every navigation inside it. Sessions already open when the level changes are
 * redirected live by BillingBlockRedirectService, without waiting for their next
 * navigation.
 */
export const BillingBlockGuard: CanActivateFn = () => {
    const platformAlertsService = inject(PlatformAlertsService);
    const router = inject(Router);

    return platformAlertsService.totalBlock$.pipe(
        take(1),
        map((blocked) =>
            blocked ? router.createUrlTree([`/${ACCOUNT_BLOCKED_PATH}`]) : true,
        ),
    );
};
